/**
 * BlackBörk Custom Patch Designer
 * Allows users to upload their own image and preview it as a patch on a hat
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    maxFileSize: 5 * 1024 * 1024, // 5MB
    allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
    patchSize: 400, // Square patch (6.5cm x 6.5cm)
    outputQuality: 0.9,
    // Model names mapping
    modelNames: {
      'A-3100': 'Béisbol Clásico',
      'A-3200': 'Béisbol Premium Cordura',
      'A-3400': 'Béisbol Niños',
      'A-3500': 'Béisbol Premium',
      'A-3510': 'Béisbol Premium 6 Paneles',
      'A-4500': 'Bucket Premium',
      'A-5400': 'Hip Hop Niños',
      'A-5410': 'Hip Hop Trucker Niños',
      'A-5500': 'Hip Hop Premium',
      'A-7100': 'Trucker Clásico',
      'A-7200': 'Trucker Premium',
      'A-7410': 'Trucker Niños',
      'A-7500': 'Trucker Premium'
    },
    // Hat images - thumbnails for grid (50-70KB each instead of 1.5MB)
    hatImages: {
      'A-3500-030303': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-3500-030303.png',
      'A-3500-090909': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-3500-090909.png',
      'A-3500-101010': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-3500-101010.png',
      'A-3500-141414': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-3500-141414.png',
      'A-3500-191919': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-3500-191919.png',
      'A-3500-202020': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-3500-202020.png',
      'A-3500-291010': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-3500-291010.png',
      'A-3500-292929': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-3500-292929.png',
      'A-3500-293434': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-3500-293434.png',
      'A-3500-303030': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-3500-303030.png',
      'A-5400-171717': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5400-171717.png',
      'A-5400-252525': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5400-252525.png',
      'A-5400-282828': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5400-282828.png',
      'A-5400-333333': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5400-333333.png',
      'A-5400-353535': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5400-353535.png',
      'A-5410-032929': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5410-032929.png',
      'A-5410-101010': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5410-101010.png',
      'A-5410-141414': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5410-141414.png',
      'A-5410-151529': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5410-151529.png',
      'A-5410-252525': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5410-252525.png',
      'A-5410-282828': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5410-282828.png',
      'A-5410-292929': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5410-292929.png',
      'A-5410-333333': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5410-333333.png',
      'A-5500-092929': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5500-092929.png',
      'A-5500-290303': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5500-290303.png',
      'A-5500-290909': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-5500-290909.png',
      'A-7100-040404': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7100-040404.png',
      'A-7100-171704': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7100-171704.png',
      'A-7100-242924': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7100-242924.png',
      'A-7100-292928': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7100-292928.png',
      'A-7200-292903': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7200-292903.png',
      'A-7500-030303': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-030303.png',
      'A-7500-030329': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-030329.png',
      'A-7500-032929': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-032929.png',
      'A-7500-101029': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-101029.png',
      'A-7500-131329': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-131329.png',
      'A-7500-141403': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-141403.png',
      'A-7500-141428': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-141428.png',
      'A-7500-142929': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-142929.png',
      'A-7500-171703': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-171703.png',
      'A-7500-290129': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-290129.png',
      'A-7500-290329': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-290329.png',
      'A-7500-291429': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-291429.png',
      'A-7500-292914': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-292914.png',
      'A-7500-292929': 'https://chronoslab.es/cdn/hats/SAPKA/thumb/A-7500-292929.png'
    },
    // Out of stock hats - these will show as faded and not selectable
    outOfStockHats: []
  };

  // ═══════════════════════════════════════════════════════════
  // Available Hat SKUs - Patchless hats with variant images in Shopify
  // These are loaded dynamically from Shopify (same as gorra-designer)
  // ═══════════════════════════════════════════════════════════
  const AVAILABLE_HAT_SKUS = new Set([
    "A-3200-101010",
    "A-3200-171717",
    "A-3200-292929",
    "A-3500-010101",
    "A-3500-020202",
    "A-3500-030303",
    "A-3500-090909",
    "A-3500-101010",
    "A-3500-102929",
    "A-3500-120212",
    "A-3500-121212",
    "A-3500-131313",
    "A-3500-141414",
    "A-3500-152929",
    "A-3500-171717",
    "A-3500-191919",
    "A-3500-202020",
    "A-3500-290101",
    "A-3500-290202",
    "A-3500-290303",
    "A-3500-291010",
    "A-3500-292020",
    "A-3500-292929",
    "A-3500-293434",
    "A-3500-303030",
    "A-7100-040404",
    "A-7100-171704",
    "A-7100-171717",
    "A-7100-242924",
    "A-7100-292928",
    "A-7200-031717",
    "A-7200-101029",
    "A-7200-171717",
    "A-7200-291010",
    "A-7200-291029",
    "A-7200-292903",
    "A-7200-292910",
    "A-7200-292914",
    "A-7200-292925",
    "A-7200-292928",
    "A-7200-292929",
    "A-7200-372929",
    "A-7500-020229",
    "A-7500-030303",
    "A-7500-030329",
    "A-7500-032929",
    "A-7500-121229",
    "A-7500-131329",
    "A-7500-141403",
    "A-7500-141428",
    "A-7500-142929",
    "A-7500-152929",
    "A-7500-171703",
    "A-7500-171717",
    "A-7500-290129",
    "A-7500-290303",
    "A-7500-290329",
    "A-7500-290929",
    "A-7500-291429",
    "A-7500-292029",
    "A-7500-292910",
    "A-7500-292914",
    "A-7500-292925",
    "A-7500-293429"
  ]);

  // ═══════════════════════════════════════════════════════════
  // Hat Variant IDs for Shopify (Patchless Hats)
  // These are the Shopify variant IDs for adding hats to cart
  // ═══════════════════════════════════════════════════════════
  const HAT_VARIANT_IDS = {
    "A-3200-101010": 57661234676095,
    "A-3200-171717": 56734567137663,
    "A-3200-292929": 56734567170431,
    "A-3500-010101": 57643189731711,
    "A-3500-020202": 56855063265663,
    "A-3500-030303": 56734573887871,
    "A-3500-090909": 56734573920639,
    "A-3500-101010": 56734573953407,
    "A-3500-102929": 57643200086399,
    "A-3500-120212": 56734573986175,
    "A-3500-121212": 56734574018943,
    "A-3500-131313": 57643201954175,
    "A-3500-141414": 56734574051711,
    "A-3500-152929": 56734574084479,
    "A-3500-171717": 56855063593343,
    "A-3500-191919": 56734574117247,
    "A-3500-202020": 56734574150015,
    "A-3500-290101": 57643202085247,
    "A-3500-290202": 57643202249087,
    "A-3500-290303": 57643202576767,
    "A-3500-291010": 56734574182783,
    "A-3500-292020": 57267242140031,
    "A-3500-292929": 56734574215551,
    "A-3500-293434": 56734574248319,
    "A-3500-303030": 56734574281087,
    "A-7100-040404": 56734588699007,
    "A-7100-171704": 56734588731775,
    "A-7100-171717": 56734588764543,
    "A-7100-242924": 56734588830079,
    "A-7100-292928": 56734588895615,
    "A-7200-031717": 57643203166591,
    "A-7200-101029": 57643203330431,
    "A-7200-171717": 57661246570879,
    "A-7200-291010": 57661249880447,
    "A-7200-291029": 57661252960639,
    "A-7200-292903": 56734590828927,
    "A-7200-292910": 57661255123327,
    "A-7200-292914": 57661257646463,
    "A-7200-292925": 56734590861695,
    "A-7200-292928": 57643203494271,
    "A-7200-292929": 56855064641919,
    "A-7200-372929": 57643203592575,
    "A-7500-020229": 57643203756415,
    "A-7500-030303": 56734601675135,
    "A-7500-030329": 56734601707903,
    "A-7500-032929": 56734601740671,
    "A-7500-121229": 56734601871743,
    "A-7500-131329": 56734601904511,
    "A-7500-141403": 56734601937279,
    "A-7500-141428": 56734601970047,
    "A-7500-142929": 56734602002815,
    "A-7500-152929": 57643203920255,
    "A-7500-171703": 56734602035583,
    "A-7500-171717": 57660733981055,
    "A-7500-290129": 56734602133887,
    "A-7500-290303": 56734602166655,
    "A-7500-290329": 56734602199423,
    "A-7500-290929": 56734602232191,
    "A-7500-291429": 56734602264959,
    "A-7500-292029": 56855064805759,
    "A-7500-292910": 57643204051327,
    "A-7500-292914": 56734602330495,
    "A-7500-292925": 56734602363263,
    "A-7500-293429": 57661274947967
  };

  // ═══════════════════════════════════════════════════════════
  // Hat Price Calculator (combo prices: hat + €4 custom patch)
  // ═══════════════════════════════════════════════════════════
  function getHatPrice(hatId) {
    const model = hatId.split('-').slice(0, 2).join('-');
    const prices = {
      'A-7200': 73, 'A-3200': 73,
      'A-5500': 63,
      'A-3500': 53, 'A-3510': 53, 'A-7500': 53, 'A-4500': 53,
      'A-3100': 43, 'A-7100': 43, 'A-3400': 43,
      'A-5400': 43, 'A-5410': 43, 'A-7410': 43
    };
    return prices[model] || 53;
  }

  // Get hat image URL from Shopify mapping
  function getHatImageUrl(hatId, useThumbnail = false) {
    const thumbUrl = CONFIG.hatImages[hatId];
    if (!thumbUrl) return null;
    // For preview, use full-size image (remove /thumb/ from path)
    if (!useThumbnail) {
      return thumbUrl.replace('/thumb/', '/');
    }
    return thumbUrl;
  }

  // Available hats = all hats that have images in Shopify
  const availableHats = Object.keys(CONFIG.hatImages);

  // State
  let state = {
    selectedHat: null,
    hats: [],
    hatsLoaded: false,
    uploadedImage: null,
    processedPatch: null,
    flatPatchForPrint: null,  // v22: Flat patch preview with zoom (no rotation) for printing
    designCode: null,
    hatsLoaded: 0,
    totalHats: 0,
    // Image adjustment settings
    fillMode: 'FILL',   // v23: Default FILL to fully cover patch area (may crop)
    zoom: 1.0,          // 1.0 = 100%, up to 2.0 = 200%
    panX: 0.0,          // Pan offset X (-1 to 1)
    panY: 0.0,          // Pan offset Y (-1 to 1)
    imageRotation: -8   // v23: More left rotation (-8 from -5)
  };

  // DOM Elements
  let elements = {};

  // ═══════════════════════════════════════════════════════════
  // Load Hats from Shopify (same method as gorra-designer)
  // ═══════════════════════════════════════════════════════════
  async function loadHatsFromShopify() {
    try {
      let allProducts = [];
      let page = 1;
      let hasMore = true;
      
      while (hasMore && page <= 10) {
        const response = await fetch(`/products.json?limit=250&page=${page}`);
        const data = await response.json();
        if (data.products && data.products.length > 0) {
          allProducts = allProducts.concat(data.products);
          hasMore = data.products.length === 250;
          page++;
        } else {
          hasMore = false;
        }
      }
      console.log(`[Custom Patch] Loaded ${allProducts.length} total products`);
      
      // Get patchsiz prices from Shopify
      const patchsizPrices = {};
      allProducts.forEach(product => {
        product.variants?.forEach(variant => {
          const sku = variant.sku || '';
          if (sku.startsWith('A-') && sku.length === 13) {
            const model = sku.substring(0, 6);
            if (!patchsizPrices[model]) {
              patchsizPrices[model] = parseFloat(variant.price);
            }
          }
        });
      });
      
      // Filter hats with variant-specific images
      const hatsFromVariants = [];
      allProducts.forEach(product => {
        const productImages = product.images || [];
        product.variants?.forEach(variant => {
          const variantSku = variant.sku || '';
          if (AVAILABLE_HAT_SKUS.has(variantSku)) {
            const variantImg = productImages.find(img => 
              img.variant_ids && img.variant_ids.includes(variant.id)
            );
            if (variantImg) {
              const model = variantSku.split('-').slice(0, 2).join('-');
              const patchsizPrice = patchsizPrices[model] || parseFloat(variant.price);
              hatsFromVariants.push({
                id: product.id,
                variantId: variant.id,
                title: product.title,
                sku: variantSku,
                model: model,
                colorId: variantSku.split('-')[2],
                price: patchsizPrice,
                image: variantImg.src,
                available: variant.available
              });
            }
          }
        });
      });
      
      state.hats = hatsFromVariants;
      state.hatsLoaded = true;
      console.log(`[Custom Patch] Found ${state.hats.length} hats with variant images`);
      
      // Populate grid after loading
      populateHatGrid();
      
    } catch (error) {
      console.error('[Custom Patch] Error loading hats:', error);
      state.hatsLoaded = true; // Mark as loaded even on error
    }
  }

  // Initialize
  function init() {
    cacheElements();
    bindEvents();
    loadHatsFromShopify();

    // Initially hide all hats (dropdown starts with "Selecciona una gorra")
    filterHats();

    // Track page view
    if (typeof fbq !== 'undefined') {
      fbq('track', 'ViewContent', { content_name: 'Custom Patch Designer' });
    }
  }

  function cacheElements() {
    elements = {
      uploadZone: document.getElementById('uploadZone'),
      fileInput: document.getElementById('fileInput'),
      uploadPreview: document.getElementById('uploadPreview'),
      uploadedImage: document.getElementById('uploadedImage'),
      removeImage: document.getElementById('removeImage'),
      modelFilter: document.getElementById('modelFilter'),
      hatGrid: document.getElementById('hatGrid'),
      previewContainer: document.getElementById('previewContainer'),
      hatPreview: document.getElementById('hatPreview'),
      patchOverlay: document.getElementById('patchOverlay'),
      patchPreview: document.getElementById('patchPreview'),
      previewEmpty: document.getElementById('previewEmpty'),
      selectedInfo: document.getElementById('selectedInfo'),
      selectedModel: document.getElementById('selectedModel'),
      selectedColor: document.getElementById('selectedColor'),
      selectedSku: document.getElementById('selectedSku'),
      addToCartBtn: document.getElementById('addToCartBtn'),
      copyrightCheckbox: document.getElementById('copyrightCheckbox'),
      copyrightDisclaimer: document.querySelector('.copyright-disclaimer'),
      exportCanvas: document.getElementById('exportCanvas'),
      designCodeValue: document.getElementById('designCodeValue'),
      // Image controls
      imageControls: document.getElementById('imageControls'),
      modeFit: document.getElementById('modeFit'),
      modeFill: document.getElementById('modeFill'),
      zoomSlider: document.getElementById('zoomSlider'),
      zoomValue: document.getElementById('zoomValue'),
      // Pan controls
      panUp: document.getElementById('panUp'),
      panDown: document.getElementById('panDown'),
      panLeft: document.getElementById('panLeft'),
      panRight: document.getElementById('panRight'),
      panReset: document.getElementById('panReset')
    };
  }

  function bindEvents() {
    // Upload zone events
    elements.uploadZone.addEventListener('click', () => elements.fileInput.click());
    elements.uploadZone.addEventListener('dragover', handleDragOver);
    elements.uploadZone.addEventListener('dragleave', handleDragLeave);
    elements.uploadZone.addEventListener('drop', handleDrop);
    elements.fileInput.addEventListener('change', handleFileSelect);

    // Remove image
    elements.removeImage.addEventListener('click', removeUploadedImage);

    // Model filter
    elements.modelFilter.addEventListener('change', filterHats);

    // Action buttons
    if (elements.addToCartBtn) {
      elements.addToCartBtn.addEventListener('click', addToCart);
    }

    // Add hat checkbox - toggle combo price display
    const addHatCheckbox = document.getElementById('addHatCheckbox');
    if (addHatCheckbox) {
      addHatCheckbox.addEventListener('change', () => {
        const comboPriceDisplay = document.getElementById('comboPriceDisplay');
        if (comboPriceDisplay) {
          comboPriceDisplay.style.display = addHatCheckbox.checked ? 'flex' : 'none';
        }
      });
    }

    // Copyright checkbox
    if (elements.copyrightCheckbox) {
      elements.copyrightCheckbox.addEventListener('change', () => {
        // Remove error state when checked
        if (elements.copyrightCheckbox.checked && elements.copyrightDisclaimer) {
          elements.copyrightDisclaimer.classList.remove('error');
        }
        updateButtons();
      });
    }

    // v33: Wire ALL stepper buttons on init (v3 section's own wiring is unreliable)
    var __bbcpGoStepGlobal = function(n) {
      document.querySelectorAll('.bbcp-pane').forEach(function(p){
        var idx = parseInt(p.dataset.pane, 10);
        p.classList.toggle('active', idx === n);
      });
      document.querySelectorAll('.bbcp-step').forEach(function(s){
        var idx = parseInt(s.dataset.go, 10);
        s.classList.toggle('active', idx === n);
        s.classList.toggle('done', idx < n);
      });
      var stepperEl = document.querySelector('.bbcp-stepper');
      if (stepperEl) window.scrollTo({ top: stepperEl.offsetTop - 80, behavior: 'smooth' });
    };
    window.__bbcpGoStep = __bbcpGoStepGlobal;
    var __wireBtn = function(id, n){
      var b = document.getElementById(id);
      if (b) b.onclick = function(){ __bbcpGoStepGlobal(n); };
    };
    __wireBtn('bbcp-next1', 2);
    __wireBtn('bbcp-back2', 1);
    __wireBtn('bbcp-next2', 3);
    __wireBtn('bbcp-back3', 2);
    // Step chips clickable
    document.querySelectorAll('.bbcp-step').forEach(function(s){
      var idx = parseInt(s.dataset.go, 10);
      s.onclick = function(){ __bbcpGoStepGlobal(idx); };
    });

    // ═══════════════════════════════════════════════════════════
    // Image Controls: FIT/FILL Toggle & Zoom Slider
    // ═══════════════════════════════════════════════════════════
    if (elements.modeFit) {
      elements.modeFit.addEventListener('click', () => setFillMode('FIT'));
    }
    if (elements.modeFill) {
      elements.modeFill.addEventListener('click', () => setFillMode('FILL'));
    }
    if (elements.zoomSlider) {
      elements.zoomSlider.addEventListener('input', handleZoomChange);
    }

    // Pan controls
    if (elements.panUp) {
      elements.panUp.addEventListener('click', () => handlePan('up'));
    }
    if (elements.panDown) {
      elements.panDown.addEventListener('click', () => handlePan('down'));
    }
    if (elements.panLeft) {
      elements.panLeft.addEventListener('click', () => handlePan('left'));
    }
    if (elements.panRight) {
      elements.panRight.addEventListener('click', () => handlePan('right'));
    }
    if (elements.panReset) {
      elements.panReset.addEventListener('click', () => handlePan('reset'));
    }

    // Window resize handler - recalculate patch position
    // Uses longer debounce + requestAnimationFrame to ensure layout is stable
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Only recalculate if hat is selected and patch is visible
        if (state.selectedHat && elements.patchOverlay && elements.patchOverlay.style.display !== 'none') {
          // Wait for next animation frame to ensure DOM layout is complete
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              initDragAndResize();
              console.log('📐 Patch repositioned after resize (v19)');
            });
          });
        }
      }, 300); // Longer debounce for layout stability
    });
  }

  // ═══════════════════════════════════════════════════════════
  // FIT/FILL Mode Toggle
  // ═══════════════════════════════════════════════════════════
  function setFillMode(mode) {
    state.fillMode = mode;

    // Update toggle button UI
    if (elements.modeFit && elements.modeFill) {
      elements.modeFit.classList.toggle('active', mode === 'FIT');
      elements.modeFill.classList.toggle('active', mode === 'FILL');
    }

    console.log('🔄 Mode changed to:', mode);

    // Re-process image with new mode
    if (state.uploadedImage) {
      processImageToPatch(state.uploadedImage);
    }
  }

  // ═══════════════════════════════════════════════════════════
  // Zoom Slider Handler
  // ═══════════════════════════════════════════════════════════
  function handleZoomChange(e) {
    const value = parseInt(e.target.value);
    state.zoom = value / 100;  // Convert 100-200 to 1.0-2.0

    // Update display
    if (elements.zoomValue) {
      elements.zoomValue.textContent = value + '%';
    }

    // Update slider gradient to show progress
    const percent = ((value - 100) / 100) * 100;  // 0-100%
    e.target.style.background = `linear-gradient(to right, #c9a227 ${percent}%, #e0e0e0 ${percent}%)`;

    console.log('🔍 Zoom changed to:', state.zoom);

    // Re-process image with new zoom
    if (state.uploadedImage) {
      processImageToPatch(state.uploadedImage);
    }
  }

  // ═══════════════════════════════════════════════════════════
  // Pan Controls - Position Adjustment
  // ═══════════════════════════════════════════════════════════
  const PAN_STEP = 0.1;  // 10% per click

  function handlePan(direction) {
    switch (direction) {
      case 'up':
        state.panY = Math.max(-1, state.panY - PAN_STEP);
        break;
      case 'down':
        state.panY = Math.min(1, state.panY + PAN_STEP);
        break;
      case 'left':
        state.panX = Math.max(-1, state.panX - PAN_STEP);
        break;
      case 'right':
        state.panX = Math.min(1, state.panX + PAN_STEP);
        break;
      case 'reset':
        state.panX = 0.0;
        state.panY = 0.0;
        break;
    }

    console.log('Pan changed to: X=' + state.panX.toFixed(2) + ', Y=' + state.panY.toFixed(2));

    // Re-process image with new pan position
    if (state.uploadedImage) {
      processImageToPatch(state.uploadedImage);
    }
  }

  // ═══════════════════════════════════════════════════════════
  // Show/Hide Image Controls
  // ═══════════════════════════════════════════════════════════
  function showImageControls() {
    if (elements.imageControls) {
      elements.imageControls.style.display = 'block';
    }
  }

  function hideImageControls() {
    if (elements.imageControls) {
      elements.imageControls.style.display = 'none';
    }
    // Reset to defaults (v23: FILL mode, -8 rotation)
    state.fillMode = 'FILL';
    state.zoom = 1.0;
    state.panX = 0.0;
    state.panY = 0.0;
    state.imageRotation = -8;

    // Reset UI (v23: FILL is default)
    if (elements.modeFit) elements.modeFit.classList.remove('active');
    if (elements.modeFill) elements.modeFill.classList.add('active');
    if (elements.zoomSlider) {
      elements.zoomSlider.value = 100;
      elements.zoomSlider.style.background = 'linear-gradient(to right, #c9a227 0%, #e0e0e0 0%)';
    }
    if (elements.zoomValue) elements.zoomValue.textContent = '100%';
  }

  // Hat Grid Population (uses dynamically loaded hats)
  function populateHatGrid() {
    const grid = elements.hatGrid;
    if (!grid) return;
    
    if (!state.hatsLoaded) {
      grid.innerHTML = '<div class="grid-loading">Cargando gorras...</div>';
      return;
    }
    
    grid.innerHTML = '';
    
    state.hats.forEach(hat => {
      const hatItem = createHatItem(hat);
      grid.appendChild(hatItem);
    });

    // Ensure grid is visible
    hideLoadingIndicator();
  }

  function showLoadingIndicator() {
    let loader = document.getElementById('hatGridLoader');
    if (!loader) {
      loader = document.createElement('div');
      loader.id = 'hatGridLoader';
      loader.className = 'hat-grid-loader';
      loader.innerHTML = '<div class="loader-spinner"></div><p>Cargando gorras... <span id="loadProgress">0</span>/' + state.totalHats + '</p>';
      elements.hatGrid.parentNode.insertBefore(loader, elements.hatGrid);
    }
    loader.style.display = 'flex';
    elements.hatGrid.style.opacity = '0.3';
  }

  function updateLoadingProgress() {
    state.hatsLoaded++;
    const progress = document.getElementById('loadProgress');
    if (progress) {
      progress.textContent = state.hatsLoaded;
    }

    // Hide loader when all hats loaded
    if (state.hatsLoaded >= state.totalHats) {
      hideLoadingIndicator();
    }
  }

  function hideLoadingIndicator() {
    const loader = document.getElementById('hatGridLoader');
    if (loader) {
      loader.style.display = 'none';
    }
    elements.hatGrid.style.opacity = '1';
  }

  function createHatItem(hat) {
    const hatId = hat.sku;
    const modelId = hat.model;
    const colorId = hat.colorId;
    const modelName = CONFIG.modelNames[modelId] || modelId;
    const variantId = hat.variantId;
    const imageUrl = hat.image;

    const item = document.createElement('div');
    item.className = 'hat-item';
    item.dataset.model = modelId;
    item.dataset.color = colorId;
    item.dataset.hatId = hatId;
    item.dataset.modelName = modelName;
    item.dataset.colorName = colorId;
    item.dataset.variantId = variantId;
    item.dataset.imageUrl = imageUrl;
    item.dataset.price = hat.price;

    const img = document.createElement('img');
    img.alt = `${modelName} ${colorId}`;
    img.src = imageUrl;
    img.dataset.hatUrl = imageUrl || '';
    img.dataset.loaded = 'true';

    item.appendChild(img);

    // Stock-aware disabling: if Shopify reports the variant as not available
    // (inventory_quantity <= 0 with deny policy), grey it out and block clicks.
    if (hat.available === false) {
      item.classList.add('out-of-stock');
      item.title = 'Sin stock — agotado';
    } else {
      item.addEventListener('click', () => selectHat(item, modelId, colorId, hatId, variantId, imageUrl));
    }

    return item;
  }

  function filterHats() {
    const filter = elements.modelFilter.value;
    const items = elements.hatGrid.querySelectorAll('.hat-item');

    // If "Selecciona una gorra" is selected, hide all hats
    if (filter === 'none') {
      items.forEach(item => {
        item.style.display = 'none';
      });
      hideLoadingIndicator(); // Hide loader when no hats shown
      return;
    }

    // Collect visible items to load
    const visibleItems = [];

    // Show hats based on filter
    items.forEach(item => {
      if (!filter || item.dataset.model === filter) {
        item.style.display = '';
        visibleItems.push(item);
      } else {
        item.style.display = 'none';
      }
    });

    // Images are loaded immediately when hat items are created
    // No need for loading indicator or sequential loading
    hideLoadingIndicator();
  }

  // Load images one by one - wait for each to complete before next (Safari compatible)
  function loadImagesSequentially(items) {
    let index = 0;
    const maxWait = 5000; // Max 5 seconds per image (increased for Safari)

    function loadNext() {
      if (index >= items.length) {
        hideLoadingIndicator(); // Ensure loader is hidden when all items processed
        return;
      }

      const item = items[index];
      const img = item.querySelector('img');
      index++;

      if (!img || !img.dataset.hatUrl || img.dataset.loaded !== 'false') {
        // Skip already loaded or invalid, move to next immediately
        setTimeout(loadNext, 10);
        return;
      }

      let loaded = false;
      const timeout = setTimeout(() => {
        if (!loaded) {
          console.warn('Image timeout, skipping:', img.dataset.hatUrl);
          loaded = true;
          updateLoadingProgress();
          loadNext();
        }
      }, maxWait);

      // Safari fix: Use addEventListener instead of onload/onerror
      // This ensures events fire properly on Safari/iOS
      const handleLoad = () => {
        if (!loaded) {
          loaded = true;
          clearTimeout(timeout);
          img.dataset.loaded = 'true';
          img.removeEventListener('load', handleLoad);
          img.removeEventListener('error', handleError);
          updateLoadingProgress();
          setTimeout(loadNext, 20); // Small delay before next
        }
      };

      const handleError = () => {
        if (!loaded) {
          loaded = true;
          clearTimeout(timeout);
          img.removeEventListener('load', handleLoad);
          img.removeEventListener('error', handleError);
          item.style.display = 'none';
          updateLoadingProgress();
          setTimeout(loadNext, 20);
        }
      };

      img.addEventListener('load', handleLoad);
      img.addEventListener('error', handleError);

      // Safari fix: Set src after event listeners are attached
      // Add cache buster for Safari to ensure fresh load
      const url = img.dataset.hatUrl;
      img.src = url;
    }

    loadNext();
  }

  function selectHat(item, modelId, colorId, hatId, variantId, imageUrl) {
    // Remove previous selection
    const prevSelected = elements.hatGrid.querySelector('.selected');
    if (prevSelected) prevSelected.classList.remove('selected');

    // Select new hat
    item.classList.add('selected');
    const modelName = CONFIG.modelNames[modelId] || modelId;
    const price = parseFloat(item.dataset.price) || getHatPrice(hatId);
    state.selectedHat = { modelId, colorId, hatId, modelName, variantId, imageUrl, price, element: item };

    // Update preview
    updateHatPreview(hatId);
    updateSelectedInfo(modelId, colorId);
    updateButtons();

    // Update hat price display for "add hat" checkbox
    updateHatPriceDisplay(hatId);

    // v34: On mobile, auto-scroll to live preview after hat selection
    if (window.innerWidth <= 1060) {
      setTimeout(function() {
        var previewEl = document.querySelector('.bbcp-preview');
        if (previewEl) {
          previewEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 250);
    }
  }

  // ═══════════════════════════════════════════════════════════
  // Update Hat Price Display (for add-hat checkbox)
  // ═══════════════════════════════════════════════════════════
  function updateHatPriceDisplay(hatId) {
    // Show the add-hat option when hat is selected
    const addHatOption = document.querySelector('.add-hat-option');
    if (addHatOption) {
      addHatOption.style.display = hatId ? 'block' : 'none';
    }

    // Update combo price display
    const comboPriceDisplay = document.getElementById('comboPriceDisplay');
    const comboTotalEl = document.getElementById('comboTotalPrice');
    const comboSavingsEl = document.getElementById('comboSavings');

    if (comboPriceDisplay && comboTotalEl && hatId) {
      const comboTotal = (state.selectedHat && state.selectedHat.price) ? state.selectedHat.price : getHatPrice(hatId);
      const separateTotal = comboTotal + 12;  // Buying hat + patch separately costs €12 more
      const savings = separateTotal - comboTotal;

      comboTotalEl.textContent = '€' + comboTotal.toFixed(2).replace('.', ',');
      if (comboSavingsEl && savings > 0) {
        comboSavingsEl.textContent = '(Ahorras €' + savings.toFixed(2).replace('.', ',') + ')';
        comboSavingsEl.style.display = '';
      }
      comboPriceDisplay.style.display = 'flex';
    }
  }

  function updateHatPreview(hatId) {
    const hatUrl = state.selectedHat.imageUrl || getHatImageUrl(hatId);
    elements.hatPreview.style.display = 'block';
    elements.previewEmpty.style.display = 'none';

    // Wait for hat image to load before positioning patch
    elements.hatPreview.onload = function() {
      // Update patch preview after hat image is fully loaded
      updatePatchPreview();
    };
    elements.hatPreview.src = hatUrl;
  }

  // Show empty patch template on hat for positioning test
  function showEmptyPatchTemplate() {
    const patchTemplateUrl = 'https://cdn.shopify.com/s/files/1/0930/4453/9775/t/41/assets/custompatch.png?v=1767826739';

    // Try to load patch template
    fetch(patchTemplateUrl, { mode: 'cors' })
      .then(response => response.blob())
      .then(blob => {
        const blobUrl = URL.createObjectURL(blob);
        state.processedPatch = blobUrl;
        elements.patchPreview.src = blobUrl;
        elements.patchOverlay.style.display = 'block';
        initDragAndResize();
        // showCoordDisplay(); // Disabled
      })
      .catch(() => {
        // Fallback: create a placeholder rectangle
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 400;
        canvas.height = 400;

        // Draw placeholder patch outline
        ctx.strokeStyle = '#000000';
        ctx.lineWidth = 15;
        ctx.fillStyle = '#ffffff';
        drawRoundedRect(ctx, 10, 10, 380, 380, 30);
        ctx.fill();
        ctx.stroke();

        // Add text
        ctx.fillStyle = '#999999';
        ctx.font = '24px sans-serif';
        ctx.textAlign = 'center';
        ctx.fillText('Sube tu imagen', 200, 200);

        state.processedPatch = canvas.toDataURL('image/png');
        elements.patchPreview.src = state.processedPatch;
        elements.patchOverlay.style.display = 'block';
        initDragAndResize();
        // showCoordDisplay(); // Disabled
      });
  }

  function updateSelectedInfo(modelId, colorId) {
    const modelName = CONFIG.modelNames[modelId] || modelId;
    const sku = modelId + '-' + colorId;
    elements.selectedModel.textContent = modelName;
    elements.selectedColor.textContent = '#' + colorId;
    if (elements.selectedSku) {
      elements.selectedSku.textContent = sku;
    }
    elements.selectedInfo.style.display = 'block';
  }

  // File Upload Handling
  function handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    elements.uploadZone.classList.add('dragover');
  }

  function handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    elements.uploadZone.classList.remove('dragover');
  }

  function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    elements.uploadZone.classList.remove('dragover');

    const files = e.dataTransfer.files;
    if (files.length > 0) {
      processFile(files[0]);
    }
  }

  function handleFileSelect(e) {
    const files = e.target.files;
    if (files.length > 0) {
      processFile(files[0]);
    }
  }

  function processFile(file) {
    // Validate file type
    if (!CONFIG.allowedTypes.includes(file.type)) {
      alert('Por favor, sube una imagen JPG, PNG o WebP.');
      return;
    }

    // Validate file size
    if (file.size > CONFIG.maxFileSize) {
      alert('El archivo es demasiado grande. Máximo 5MB.');
      return;
    }

    // Read and process image
    const reader = new FileReader();
    reader.onload = async (e) => {
      const dataUrl = e.target.result;

      // v11: Copyright check via vision AI before processing
      // Show verifying message in upload zone
      const uploadZoneContent = elements.uploadZone.querySelector('.upload-zone__content');
      const originalContent = uploadZoneContent ? uploadZoneContent.innerHTML : '';
      if (uploadZoneContent) {
        uploadZoneContent.innerHTML = '<div style="text-align:center;padding:20px;"><div class="copyright-spinner" style="width:40px;height:40px;border:3px solid #e0e0e0;border-top:3px solid #c9a227;border-radius:50%;animation:spin 1s linear infinite;margin:0 auto 12px;"></div><p style="color:#666;font-size:0.95rem;margin:0;">Verificando derechos de autor...</p></div>';
      }
      try {
        const copyrightOk = await checkImageCopyright(dataUrl);
        if (!copyrightOk) {
          // Restore upload zone
          if (uploadZoneContent) uploadZoneContent.innerHTML = originalContent;
          elements.fileInput.value = '';
          return;
        }
      } catch (err) {
        console.log('Copyright check skipped:', err.message);
      }
      // Restore upload zone content (will be hidden by showUploadPreview)
      if (uploadZoneContent) uploadZoneContent.innerHTML = originalContent;

      state.uploadedImage = dataUrl;
      showUploadPreview(dataUrl);
      processImageToPatch(dataUrl);

      // Track upload event
      if (typeof fbq !== 'undefined') {
        fbq('trackCustom', 'PatchImageUploaded');
      }
    };
    reader.readAsDataURL(file);
  }

  function showUploadPreview(dataUrl) {
    // Initially show raw image, will be replaced with composited patch
    elements.uploadedImage.src = dataUrl;
    elements.uploadPreview.style.display = 'block';
    elements.uploadZone.style.display = 'none';

    // v31: Enable stepper button + attach own click handler (v3 section handler may not be wired)
    var __bbcpGoStep = function(n) {
      document.querySelectorAll('.bbcp-pane').forEach(function(p){
        var idx = parseInt(p.dataset.pane, 10);
        p.classList.toggle('active', idx === n);
      });
      document.querySelectorAll('.bbcp-step').forEach(function(s){
        var idx = parseInt(s.dataset.go, 10);
        s.classList.toggle('active', idx === n);
        s.classList.toggle('done', idx < n);
        if (idx <= n) s.disabled = false;
      });
      var stepperEl = document.querySelector('.bbcp-stepper');
      if (stepperEl) window.scrollTo({ top: stepperEl.offsetTop - 80, behavior: 'smooth' });
    };
    var __bbcpNext1 = document.getElementById('bbcp-next1');
    if (__bbcpNext1) {
      __bbcpNext1.disabled = false;
      __bbcpNext1.onclick = function(){ __bbcpGoStep(2); };
    }
    var __bbcpNext2 = document.getElementById('bbcp-next2');
    if (__bbcpNext2) {
      __bbcpNext2.disabled = false;
      __bbcpNext2.onclick = function(){ __bbcpGoStep(3); };
    }
    // Enable step chip clicking for 2 and 3
    document.querySelectorAll('.bbcp-step').forEach(function(s){
      var idx = parseInt(s.dataset.go, 10);
      if (idx === 2 || idx === 3) {
        s.disabled = false;
        s.onclick = function(){ if (!s.disabled) __bbcpGoStep(idx); };
      }
    });

    // Generate and display design code
    if (!state.designCode) {
      state.designCode = generateDesignCode();
    }
    if (elements.designCodeValue) {
      elements.designCodeValue.textContent = state.designCode;
    }

    // Show image controls (FIT/FILL, Zoom)
    showImageControls();
  }

  // Update upload preview with the composited patch (image inside flat frame)
  function updateUploadPreviewWithPatch() {
    if (!state.uploadedImage) return;

    // Create flat preview using patchempty.jpg template
    createFlatPatchPreview(state.uploadedImage);
  }

  // Create a flat patch preview using patchempty-transparent.png (already has transparent corners)
  // v21: Uses same FIT/FILL, zoom, and rotation settings as the hat preview
  function createFlatPatchPreview(userImageDataUrl) {
    const userImg = new Image();
    userImg.onload = () => {
      fetch(FLAT_TEMPLATE.url, { mode: 'cors' })
        .then(response => response.blob())
        .then(blob => {
          const templateImg = new Image();
          templateImg.onload = () => {
            const crop = FLAT_TEMPLATE.crop;
            const inner = FLAT_TEMPLATE.inner;

            // Step 1: Create user image layer using same settings as compositeImages
            const userCanvas = document.createElement('canvas');
            userCanvas.width = crop.w;
            userCanvas.height = crop.h;
            const userCtx = userCanvas.getContext('2d');

            // Clip to inner area first
            userCtx.beginPath();
            drawRoundedRectPath(userCtx, inner.x, inner.y, inner.w, inner.h, inner.radius);
            userCtx.clip();

            // Use same drawImageFitOrFill for consistent appearance
            // BUT NO ROTATION for upload preview - keep it flat/straight
            drawImageFitOrFill(userCtx, userImg, inner.x, inner.y, inner.w, inner.h, {
              padding: 2,
              mode: state.fillMode,
              zoom: state.zoom,
              panX: state.panX,
              panY: state.panY,
              rotation: 0  // NO rotation for upload preview - stays flat
            });

            // Step 2: Draw template frame on top (already has transparent corners)
            const templateCanvas = document.createElement('canvas');
            templateCanvas.width = crop.w;
            templateCanvas.height = crop.h;
            const templateCtx = templateCanvas.getContext('2d');

            templateCtx.drawImage(templateImg,
              crop.x, crop.y, crop.w, crop.h,
              0, 0, crop.w, crop.h
            );

            // Punch out the inner white area from template frame
            templateCtx.save();
            templateCtx.globalCompositeOperation = 'destination-out';
            templateCtx.beginPath();
            drawRoundedRectPath(templateCtx, inner.x, inner.y, inner.w, inner.h, inner.radius);
            templateCtx.fill();
            templateCtx.restore();

            // Step 3: Combine - user image behind, patch frame on top
            const finalCanvas = document.createElement('canvas');
            finalCanvas.width = crop.w;
            finalCanvas.height = crop.h;
            const finalCtx = finalCanvas.getContext('2d');

            finalCtx.drawImage(userCanvas, 0, 0);
            finalCtx.drawImage(templateCanvas, 0, 0);

            // Update preview with PNG (preserves transparency)
            const dataUrl = finalCanvas.toDataURL('image/png', 0.95);
            elements.uploadedImage.src = dataUrl;
            elements.uploadedImage.style.objectFit = 'contain';

            // v22: Store flat patch for printing (with zoom, NO rotation)
            state.flatPatchForPrint = dataUrl;

            console.log('v22: Flat patch preview updated (zoom applied, no rotation) - saved for printing');
          };
          templateImg.src = URL.createObjectURL(blob);
        })
        .catch(err => {
          console.error('Failed to load flat template:', err);
          if (state.processedPatch) {
            elements.uploadedImage.src = state.processedPatch;
          }
        });
    };
    userImg.src = userImageDataUrl;
  }

  function removeUploadedImage(e) {
    e.stopPropagation();
    state.uploadedImage = null;
    state.processedPatch = null;
    state.designCode = null;  // Clear design code
    elements.uploadPreview.style.display = 'none';
    elements.uploadZone.style.display = 'block';
    elements.fileInput.value = '';
    elements.patchOverlay.style.display = 'none';
    if (elements.designCodeValue) {
      elements.designCodeValue.textContent = '-';
    }

    // Hide image controls and reset settings
    hideImageControls();

    updateButtons();
  }

  function processImageToPatch(dataUrl) {
    // Load the patch template and user image, composite them
    const patchTemplateUrl = 'https://cdn.shopify.com/s/files/1/0930/4453/9775/t/41/assets/custompatch.png?v=1767826739';

    const userImg = new Image();
    let patchImg = null;

    // First load user image
    userImg.onload = () => {
      console.log('User image loaded:', userImg.width, 'x', userImg.height);

      // Try to fetch patch template
      fetch(patchTemplateUrl, { mode: 'cors' })
        .then(response => {
          if (!response.ok) throw new Error('Fetch failed');
          return response.blob();
        })
        .then(blob => {
          const blobUrl = URL.createObjectURL(blob);
          patchImg = new Image();
          patchImg.onload = () => {
            console.log('Patch template loaded via fetch:', patchImg.width, 'x', patchImg.height);
            compositeImages(userImg, patchImg);
            URL.revokeObjectURL(blobUrl);
          };
          patchImg.onerror = () => {
            console.error('Patch template blob failed to load');
            createFallbackPatch(userImg);
          };
          patchImg.src = blobUrl;
        })
        .catch(err => {
          console.log('Fetch failed, trying direct load:', err);
          // Fallback: try direct image load
          patchImg = new Image();
          patchImg.crossOrigin = 'anonymous';
          patchImg.onload = () => {
            console.log('Patch template loaded directly:', patchImg.width, 'x', patchImg.height);
            compositeImages(userImg, patchImg);
          };
          patchImg.onerror = () => {
            console.log('Direct load also failed, using fallback border');
            createFallbackPatch(userImg);
          };
          patchImg.src = patchTemplateUrl;
        });
    };

    userImg.onerror = () => console.error('Failed to load user image');
    userImg.src = dataUrl;
  }

  // Fallback: Create a simple rounded rectangle border if template fails
  function createFallbackPatch(userImg) {
    console.log('Creating fallback patch with programmatic border');
    const OUTPUT_SIZE = 500;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = OUTPUT_SIZE;
    canvas.height = OUTPUT_SIZE;

    const borderWidth = 20;
    const radius = 40;

    // Draw user image first (fill the canvas)
    const scale = Math.max(OUTPUT_SIZE / userImg.width, OUTPUT_SIZE / userImg.height);
    const scaledW = userImg.width * scale;
    const scaledH = userImg.height * scale;
    const imgX = (OUTPUT_SIZE - scaledW) / 2;
    const imgY = (OUTPUT_SIZE - scaledH) / 2;

    // Clip to rounded rectangle
    ctx.save();
    drawRoundedRect(ctx, borderWidth, borderWidth, OUTPUT_SIZE - borderWidth * 2, OUTPUT_SIZE - borderWidth * 2, radius);
    ctx.clip();
    ctx.drawImage(userImg, imgX, imgY, scaledW, scaledH);
    ctx.restore();

    // Draw black border
    ctx.strokeStyle = '#000000';
    ctx.lineWidth = borderWidth;
    drawRoundedRect(ctx, borderWidth / 2, borderWidth / 2, OUTPUT_SIZE - borderWidth, OUTPUT_SIZE - borderWidth, radius);
    ctx.stroke();

    state.processedPatch = canvas.toDataURL('image/png', 0.95);
    console.log('Fallback patch created');
    updateUploadPreviewWithPatch();
    updatePatchPreview();
    updateButtons();
  }

  // Draw image with "contain" scaling (fit inside, keep aspect ratio, centered)
  function drawImageContain(ctx, img, x, y, w, h, padding = 0) {
    const ix = x + padding;
    const iy = y + padding;
    const iw = Math.max(1, w - padding * 2);
    const ih = Math.max(1, h - padding * 2);

    // Use "contain" scaling - fit inside without overflow
    const scale = Math.min(iw / img.width, ih / img.height);
    const dw = img.width * scale;
    const dh = img.height * scale;

    // Center the image
    const dx = ix + (iw - dw) / 2;
    const dy = iy + (ih - dh) / 2;

    ctx.drawImage(img, dx, dy, dw, dh);
  }

  // Patch template dimensions
  // OLD custompatch.png (for hat preview): 2000x2000, visible patch area centered
  const CROP = { x: 895, y: 820, w: 420, h: 410 };

  // Inner area for OLD template - relative to CROP
  const INNER = {
    x: 42, y: 28, w: 347, h: 340, radius: 20
  };
  const INNER_PADDING = 2;  // Reduced from 4 for better fill

  // ═══════════════════════════════════════════════════════════════
  // PERSPECTIVE + CURVATURE SYSTEM
  // Maps user image to patch's inner quad with hat surface curve
  // ═══════════════════════════════════════════════════════════════

  // ═══════════════════════════════════════════════════════════════
  // INNER_QUAD: The perspective projection surface
  // This is NOT a container - it's the 3D surface we PROJECT onto
  //
  // v14: SUBTLE perspective - almost rectangular with very mild convergence
  // NO ROTATION - top and bottom edges are HORIZONTAL
  // ═══════════════════════════════════════════════════════════════
  const INNER_QUAD = {
    // Coordinates relative to CROP (420x410)
    // SUBTLE PERSPECTIVE: slight convergence toward top, NO TILT
    tl: { x: 50, y: 35 },     // Top-left
    tr: { x: 370, y: 35 },    // Top-right (SAME Y as top-left = no rotation)
    br: { x: 378, y: 365 },   // Bottom-right (slightly wider)
    bl: { x: 42, y: 365 }     // Bottom-left (SAME Y as bottom-right = no rotation)
  };

  // Curvature strength (0 = flat, 0.04-0.06 = very subtle)
  let CURVATURE_STRENGTH = 0.05;

  // Fill mode: 'fit' (no crop) or 'fill' (cover, may crop)
  let FILL_MODE = 'fit';

  // Skew parameters for perspective effect (disabled for now)
  let SKEW_X = 0;  // No horizontal skew
  let SKEW_Y = 0;  // No vertical skew

  // Dev controls
  window.setCurvature = function(strength) {
    CURVATURE_STRENGTH = strength;
    console.log('Curvature:', strength);
    if (state.uploadedImage) processImageToPatch(state.uploadedImage);
  };

  window.setFillMode = function(mode) {
    FILL_MODE = mode === 'fill' ? 'fill' : 'fit';
    console.log('Fill mode:', FILL_MODE);
    if (state.uploadedImage) processImageToPatch(state.uploadedImage);
  };

  /**
   * HOMOGRAPHY: Project source image ONTO destination quad surface
   * This is NOT placing an image inside a container.
   * It's projecting the image onto a 3D perspective surface.
   *
   * Uses bilinear interpolation for smooth surface mapping.
   *
   * @param {HTMLImageElement|HTMLCanvasElement} srcImg - Source image to project
   * @param {Object} dstQuad - {tl, tr, br, bl} destination quad corners
   * @param {number} outW - Output canvas width
   * @param {number} outH - Output canvas height
   * @returns {HTMLCanvasElement}
   */
  function perspectiveTransform(srcImg, dstQuad, outW, outH) {
    const canvas = document.createElement('canvas');
    canvas.width = outW;
    canvas.height = outH;
    const ctx = canvas.getContext('2d');

    const srcW = srcImg.width || srcImg.naturalWidth;
    const srcH = srcImg.height || srcImg.naturalHeight;

    // Higher resolution for smoother projection
    const gridX = 80;  // Horizontal divisions
    const gridY = 80;  // Vertical divisions

    // For each cell in the grid, map source → destination
    for (let iy = 0; iy < gridY; iy++) {
      for (let ix = 0; ix < gridX; ix++) {
        // Normalized coordinates (0-1)
        const u1 = ix / gridX;
        const v1 = iy / gridY;
        const u2 = (ix + 1) / gridX;
        const v2 = (iy + 1) / gridY;

        // Source rectangle (from original image)
        const sx = u1 * srcW;
        const sy = v1 * srcH;
        const sw = (u2 - u1) * srcW;
        const sh = (v2 - v1) * srcH;

        // Destination quad corners (bilinear interpolation on dstQuad)
        // This creates the perspective projection
        const d1 = bilinearInterp(dstQuad, u1, v1);  // top-left of cell
        const d2 = bilinearInterp(dstQuad, u2, v1);  // top-right of cell
        const d3 = bilinearInterp(dstQuad, u2, v2);  // bottom-right of cell
        const d4 = bilinearInterp(dstQuad, u1, v2);  // bottom-left of cell

        // Draw source cell into destination quadrilateral using clip path
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(d1.x, d1.y);
        ctx.lineTo(d2.x, d2.y);
        ctx.lineTo(d3.x, d3.y);
        ctx.lineTo(d4.x, d4.y);
        ctx.closePath();
        ctx.clip();

        // Calculate bounding box for this cell
        const minX = Math.min(d1.x, d2.x, d3.x, d4.x);
        const minY = Math.min(d1.y, d2.y, d3.y, d4.y);
        const maxX = Math.max(d1.x, d2.x, d3.x, d4.x);
        const maxY = Math.max(d1.y, d2.y, d3.y, d4.y);

        // Draw with slight padding to avoid gaps
        ctx.drawImage(srcImg,
          sx, sy, Math.max(1, sw), Math.max(1, sh),
          minX - 0.5, minY - 0.5, maxX - minX + 1, maxY - minY + 1
        );
        ctx.restore();
      }
    }

    console.log('🎯 Homography: ' + srcW + 'x' + srcH + ' → quad (grid ' + gridX + 'x' + gridY + ')');
    return canvas;
  }

  /**
   * Bilinear interpolation on a quad
   * Maps normalized (u,v) coordinates to actual quad position
   */
  function bilinearInterp(quad, u, v) {
    // Top edge: tl → tr
    const top = {
      x: quad.tl.x + (quad.tr.x - quad.tl.x) * u,
      y: quad.tl.y + (quad.tr.y - quad.tl.y) * u
    };
    // Bottom edge: bl → br
    const bot = {
      x: quad.bl.x + (quad.br.x - quad.bl.x) * u,
      y: quad.bl.y + (quad.br.y - quad.bl.y) * u
    };
    // Interpolate between top and bottom
    return {
      x: top.x + (bot.x - top.x) * v,
      y: top.y + (bot.y - top.y) * v
    };
  }

  // Linear interpolation for 2D points
  function lerp2D(p1, p2, t) {
    return {
      x: p1.x + (p2.x - p1.x) * t,
      y: p1.y + (p2.y - p1.y) * t
    };
  }

  /**
   * Apply surface curvature to simulate cap fabric tension
   *
   * The cap front panel is a curved surface:
   * - CENTER appears CLOSER to camera (bulges forward)
   * - EDGES appear FARTHER (recede backward)
   *
   * This is achieved by:
   * 1. Horizontal squeeze at edges (perspective narrowing)
   * 2. Vertical arc (center higher than edges)
   *
   * @param {HTMLCanvasElement} srcCanvas - Perspective-warped image
   * @param {number} strength - Curvature amount (0.06-0.08 = subtle, realistic)
   * @returns {HTMLCanvasElement}
   */
  function applyCurvature(srcCanvas, strength) {
    if (strength === 0) return srcCanvas;

    const canvas = document.createElement('canvas');
    canvas.width = srcCanvas.width;
    canvas.height = srcCanvas.height;
    const ctx = canvas.getContext('2d');

    const strips = 60;
    const stripW = srcCanvas.width / strips;

    // Curvature parameters
    const verticalBulge = srcCanvas.height * strength * 0.5;  // Vertical offset (center rises)
    const horizontalSqueeze = strength * 0.15;  // Edge compression

    for (let i = 0; i < strips; i++) {
      // Normalized position: -1 (left edge) to +1 (right edge)
      const normalized = (i / (strips - 1)) * 2 - 1;

      // Parabolic curve: edges dip, center rises
      // y = 1 - x² (inverted parabola, center at 1, edges at 0)
      const curve = 1 - normalized * normalized;

      // Vertical offset: center rises (negative Y = up)
      const offsetY = -curve * verticalBulge;

      // Horizontal scale: edges slightly narrower (farther away)
      const scaleX = 1 - (1 - curve) * horizontalSqueeze;

      // Calculate strip position with scale adjustment
      const srcX = i * stripW;
      const dstX = srcCanvas.width / 2 + (srcX - srcCanvas.width / 2) * scaleX;

      ctx.drawImage(srcCanvas,
        srcX, 0, stripW + 1, srcCanvas.height,  // Source strip
        dstX - stripW * scaleX / 2, offsetY, stripW * scaleX + 1, srcCanvas.height  // Dest with curve
      );
    }

    console.log('🌀 Surface curvature: strength=' + (strength * 100).toFixed(0) + '% bulge=' + verticalBulge.toFixed(1) + 'px');
    return canvas;
  }

  /**
   * Render user image into patch with perspective + curvature
   * @param {HTMLImageElement} userImg
   * @returns {HTMLCanvasElement}
   */
  function renderPatchInner(userImg) {
    console.log('Rendering with perspective + curvature...');
    console.log('Curvature:', CURVATURE_STRENGTH, 'Mode:', FILL_MODE);

    // Step 1: Perspective transform to quad
    const warped = perspectiveTransform(userImg, INNER_QUAD, CROP.w, CROP.h, FILL_MODE);

    // Step 2: Apply curvature
    const curved = applyCurvature(warped, CURVATURE_STRENGTH);

    return curved;
  }

  /**
   * Rotate an image by given degrees and return a new canvas
   * @param {HTMLImageElement|HTMLCanvasElement} img - Source image
   * @param {number} deg - Rotation in degrees
   * @returns {HTMLCanvasElement} - Rotated image canvas
   */
  function rotateImageToCanvas(img, deg) {
    const rad = deg * Math.PI / 180;

    // Calculate bounding box for rotated image
    const sin = Math.abs(Math.sin(rad));
    const cos = Math.abs(Math.cos(rad));
    const w = img.width;
    const h = img.height;
    const newW = Math.ceil(w * cos + h * sin);
    const newH = Math.ceil(w * sin + h * cos);

    const c = document.createElement('canvas');
    c.width = newW;
    c.height = newH;
    const ctx = c.getContext('2d');

    // Rotate around center
    ctx.translate(newW / 2, newH / 2);
    ctx.rotate(rad);
    ctx.drawImage(img, -w / 2, -h / 2);

    return c;
  }

  // Dev control: tune rotation angle quickly
  window.setPatchRotation = function(deg) {
    PATCH_ROT_DEG = deg;
    console.log('Patch rotation set to:', deg, 'degrees');
    // Re-process if image exists
    if (state.uploadedImage) {
      processImageToPatch(state.uploadedImage);
    }
  };

  // Dev control: tune skew for perspective effect
  window.setSkew = function(x, y) {
    SKEW_X = x !== undefined ? x : SKEW_X;
    SKEW_Y = y !== undefined ? y : SKEW_Y;
    console.log('Skew set to: X=' + SKEW_X + ', Y=' + SKEW_Y);
    if (state.uploadedImage) {
      processImageToPatch(state.uploadedImage);
    }
  };

  /**
   * Apply skew transform to an image for perspective effect
   * @param {HTMLCanvasElement} img - Source canvas/image
   * @param {number} skewX - Horizontal skew factor
   * @param {number} skewY - Vertical skew factor
   * @returns {HTMLCanvasElement} - Skewed image canvas
   */
  function applySkewToCanvas(img, skewX, skewY) {
    // If no skew, return original
    if (skewX === 0 && skewY === 0) return img;

    const c = document.createElement('canvas');
    // Calculate how much extra space needed for skew
    const extraW = Math.abs(skewX) * img.height * 2;
    const extraH = Math.abs(skewY) * img.width * 2;
    c.width = Math.ceil(img.width + extraW);
    c.height = Math.ceil(img.height + extraH);
    const ctx = c.getContext('2d');

    // Move to center, apply skew, draw centered
    ctx.translate(c.width / 2, c.height / 2);
    ctx.transform(1, skewY, skewX, 1, 0, 0);
    ctx.drawImage(img, -img.width / 2, -img.height / 2);

    return c;
  }

  // NEW patchempty-transparent.png template for flat preview (1536x1536, RGBA with transparent corners)
  const FLAT_TEMPLATE = {
    url: 'https://cdn.shopify.com/s/files/1/0930/4453/9775/t/41/assets/patchempty-transparent.png?v=1767904026',
    fullWidth: 1536,
    fullHeight: 1536,
    // Crop bounds (patch area - opaque pixels)
    crop: {
      x: 312,
      y: 318,
      w: 918,
      h: 906
    },
    // Inner white area (relative to crop)
    inner: {
      x: 47,    // 359 - 312
      y: 40,    // 358 - 318
      w: 824,
      h: 817,
      radius: 35
    }
  };

  // ═══════════════════════════════════════════════════════════════
  // DEBUG CALIBRATION MODE - Click to find INNER coordinates
  // Enable by calling: window.enablePatchCalibration()
  // ═══════════════════════════════════════════════════════════════
  let calibrationClicks = [];
  let calibrationCanvas = null;

  window.enablePatchCalibration = function() {
    const patchTemplateUrl = 'https://cdn.shopify.com/s/files/1/0930/4453/9775/t/41/assets/custompatch.png';

    // Create calibration overlay
    const overlay = document.createElement('div');
    overlay.id = 'calibrationOverlay';
    overlay.style.cssText = `
      position: fixed; top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(0,0,0,0.9); z-index: 99999;
      display: flex; flex-direction: column; align-items: center; justify-content: center;
    `;

    const instructions = document.createElement('div');
    instructions.style.cssText = 'color: #fff; margin-bottom: 20px; font-size: 18px; text-align: center;';
    instructions.innerHTML = `
      <h2>🎯 Patch Calibration Mode</h2>
      <p>Click <strong>TOP-LEFT</strong> corner of white inner area, then <strong>BOTTOM-RIGHT</strong></p>
      <p id="calibStatus">Waiting for click 1 (top-left)...</p>
    `;
    overlay.appendChild(instructions);

    calibrationCanvas = document.createElement('canvas');
    calibrationCanvas.style.cssText = 'border: 2px solid #c9a227; cursor: crosshair; max-width: 90vw; max-height: 70vh;';
    overlay.appendChild(calibrationCanvas);

    const closeBtn = document.createElement('button');
    closeBtn.textContent = '✕ Close';
    closeBtn.style.cssText = 'margin-top: 20px; padding: 10px 30px; font-size: 16px; cursor: pointer;';
    closeBtn.onclick = () => overlay.remove();
    overlay.appendChild(closeBtn);

    document.body.appendChild(overlay);
    calibrationClicks = [];

    // Load and draw patch template
    fetch(patchTemplateUrl, { mode: 'cors' })
      .then(r => r.blob())
      .then(blob => {
        const img = new Image();
        img.onload = () => {
          // Draw cropped portion
          calibrationCanvas.width = CROP.w;
          calibrationCanvas.height = CROP.h;
          const ctx = calibrationCanvas.getContext('2d');
          ctx.drawImage(img, CROP.x, CROP.y, CROP.w, CROP.h, 0, 0, CROP.w, CROP.h);

          // Add click handler
          calibrationCanvas.onclick = handleCalibrationClick;
        };
        img.src = URL.createObjectURL(blob);
      })
      .catch(err => {
        alert('Failed to load patch template: ' + err);
        overlay.remove();
      });
  };

  function handleCalibrationClick(e) {
    const rect = calibrationCanvas.getBoundingClientRect();
    const scaleX = calibrationCanvas.width / rect.width;
    const scaleY = calibrationCanvas.height / rect.height;
    const x = Math.round((e.clientX - rect.left) * scaleX);
    const y = Math.round((e.clientY - rect.top) * scaleY);

    calibrationClicks.push({ x, y });
    const ctx = calibrationCanvas.getContext('2d');

    // Draw marker
    ctx.fillStyle = calibrationClicks.length === 1 ? '#00ff00' : '#ff0000';
    ctx.beginPath();
    ctx.arc(x, y, 8, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#fff';
    ctx.font = 'bold 14px sans-serif';
    ctx.fillText(calibrationClicks.length === 1 ? 'TL' : 'BR', x + 12, y + 5);

    const status = document.getElementById('calibStatus');

    if (calibrationClicks.length === 1) {
      status.innerHTML = `✅ TL: (${x}, ${y}) - Now click <strong>BOTTOM-RIGHT</strong>`;
    } else if (calibrationClicks.length === 2) {
      const tl = calibrationClicks[0];
      const br = calibrationClicks[1];
      const innerConfig = {
        x: tl.x,
        y: tl.y,
        w: br.x - tl.x,
        h: br.y - tl.y,
        radius: 20
      };

      // Draw rectangle showing selection
      ctx.strokeStyle = '#c9a227';
      ctx.lineWidth = 2;
      ctx.setLineDash([5, 5]);
      ctx.strokeRect(tl.x, tl.y, innerConfig.w, innerConfig.h);

      const jsonStr = JSON.stringify(innerConfig, null, 2);
      status.innerHTML = `
        <div style="background:#222; padding:15px; border-radius:8px; margin-top:10px;">
          <p style="color:#0f0; margin:0 0 10px;">✅ Calibration Complete!</p>
          <pre style="color:#c9a227; text-align:left; margin:0;">${jsonStr}</pre>
          <button onclick="navigator.clipboard.writeText('${JSON.stringify(innerConfig)}').then(()=>alert('Copied!'))"
                  style="margin-top:10px; padding:8px 20px; cursor:pointer;">
            📋 Copy JSON
          </button>
        </div>
      `;
      console.log('📐 CALIBRATED INNER:', innerConfig);
    }
  }

  /**
   * Create a binary mask from the patch template's inner white area.
   * White/light pixels become opaque, everything else becomes transparent.
   * This captures the EXACT curved/skewed shape of the inner area.
   *
   * @param {HTMLImageElement} patchImg - custompatch.png template
   * @returns {HTMLCanvasElement} mask canvas
   */
  function createMaskFromTemplate(patchImg) {
    const maskCanvas = document.createElement('canvas');
    maskCanvas.width = CROP.w;
    maskCanvas.height = CROP.h;
    const maskCtx = maskCanvas.getContext('2d');

    // Draw cropped portion of template
    maskCtx.drawImage(patchImg, CROP.x, CROP.y, CROP.w, CROP.h, 0, 0, CROP.w, CROP.h);

    // Extract pixel data
    const imageData = maskCtx.getImageData(0, 0, CROP.w, CROP.h);
    const data = imageData.data;

    // Convert to binary mask: white/light pixels = opaque, else = transparent
    // The inner area has brightness ~235, border is dark (~15)
    for (let i = 0; i < data.length; i += 4) {
      const brightness = (data[i] + data[i+1] + data[i+2]) / 3;
      if (brightness > 200 && data[i+3] > 200) {
        // Inner area pixel - make fully opaque white
        data[i] = data[i+1] = data[i+2] = 255;
        data[i+3] = 255;
      } else {
        // Border/outside - make fully transparent
        data[i+3] = 0;
      }
    }

    maskCtx.putImageData(imageData, 0, 0);
    console.log('Mask created from template inner area');
    return maskCanvas;
  }

  /**
   * Find the bounding box of opaque pixels in a mask canvas.
   *
   * @param {HTMLCanvasElement} maskCanvas - The mask canvas
   * @returns {Object} bounds { x, y, w, h }
   */
  function getMaskBounds(maskCanvas) {
    const ctx = maskCanvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, maskCanvas.width, maskCanvas.height);
    const data = imageData.data;

    let minX = maskCanvas.width, maxX = 0;
    let minY = maskCanvas.height, maxY = 0;

    for (let y = 0; y < maskCanvas.height; y++) {
      for (let x = 0; x < maskCanvas.width; x++) {
        const i = (y * maskCanvas.width + x) * 4;
        if (data[i + 3] > 200) {  // Opaque pixel
          minX = Math.min(minX, x);
          maxX = Math.max(maxX, x);
          minY = Math.min(minY, y);
          maxY = Math.max(maxY, y);
        }
      }
    }

    const bounds = { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
    console.log('Mask bounds:', bounds);
    return bounds;
  }

  // ═══════════════════════════════════════════════════════════════
  // AUTO MODE CONFIGURATION
  // Goal: Make result INDISTINGUISHABLE from original product photos
  // The user image must FULLY FILL the patch inner area like a real stitched patch
  // ═══════════════════════════════════════════════════════════════
  const AUTO_CONFIG = {
    // ═══════════════════════════════════════════════════════
    // Surface curvature: simulates cap fabric tension
    // - Center appears CLOSER to camera (bulges forward)
    // - Edges appear FARTHER (recede backward)
    // - 0.06-0.08 = subtle, realistic
    // - Do NOT distort logo readability
    // ═══════════════════════════════════════════════════════
    curveStrength: 0.07  // 7% - subtle horizontal bulge
  };

  /**
   * Draw image with FIT or FILL mode, zoom, and rotation support
   *
   * @param {CanvasRenderingContext2D} ctx - Canvas context
   * @param {HTMLImageElement} img - Image to draw
   * @param {number} x - Left position of target area
   * @param {number} y - Top position of target area
   * @param {number} w - Width of target area
   * @param {number} h - Height of target area
   * @param {Object} opts - Options { padding, mode, zoom, panX, panY, rotation }
   */
  function drawImageFitOrFill(ctx, img, x, y, w, h, opts = {}) {
    const {
      padding = 0,
      mode = 'FIT',
      zoom = 1.0,
      panX = 0.0,
      panY = 0.0,
      rotation = 0  // Degrees to rotate image (negative = counter-clockwise/left)
    } = opts;

    // Apply padding
    const ix = x + padding;
    const iy = y + padding;
    const iw = Math.max(1, w - padding * 2);
    const ih = Math.max(1, h - padding * 2);

    // Calculate base scales
    const scaleFit = Math.min(iw / img.width, ih / img.height);
    const scaleFill = Math.max(iw / img.width, ih / img.height);

    // Select scale based on mode
    let scale = (mode === 'FILL') ? scaleFill : scaleFit;

    // Apply zoom
    scale *= zoom;

    // Calculate scaled dimensions
    const dw = img.width * scale;
    const dh = img.height * scale;

    // Center position (before pan)
    let dx = ix + (iw - dw) / 2;
    let dy = iy + (ih - dh) / 2;

    // Apply pan offset — always allow repositioning within the target area
    const panRangeX = Math.max(iw / 4, (dw - iw) / 2);
    const panRangeY = Math.max(ih / 4, (dh - ih) / 2);
    dx -= panX * panRangeX;
    dy -= panY * panRangeY;

    // Draw the image with rotation
    ctx.save();

    // Calculate center point of the target area for rotation
    const centerX = ix + iw / 2;
    const centerY = iy + ih / 2;

    // Rotate around center
    ctx.translate(centerX, centerY);
    ctx.rotate(rotation * Math.PI / 180);
    ctx.translate(-centerX, -centerY);

    // Draw the image
    ctx.drawImage(img, dx, dy, dw, dh);

    ctx.restore();

    return { dx, dy, dw, dh, scale };
  }

  /**
   * PROJECT user image ONTO patch surface
   *
   * v19: Supports FIT/FILL toggle and Zoom slider
   *
   * MODES:
   * - FIT: Entire image visible, may have margins (no crop)
   * - FILL: Image covers entire area, may crop edges
   *
   * ZOOM: 1.0 (100%) to 2.0 (200%) enlargement
   *
   * @param {HTMLImageElement} userImg - User uploaded image
   * @param {HTMLImageElement} patchImg - custompatch.png template
   */
  function compositeImages(userImg, patchImg) {
    console.log('═══════════════════════════════════════════════════════');
    console.log('🎯 v19 FIT/FILL + ZOOM');
    console.log('Mode:', state.fillMode, '| Zoom:', (state.zoom * 100).toFixed(0) + '%');
    console.log('═══════════════════════════════════════════════════════');

    // Output canvas = cropped patch size
    const canvas = document.createElement('canvas');
    canvas.width = CROP.w;   // 420
    canvas.height = CROP.h;  // 410
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // ═══════════════════════════════════════════════════════
    // STEP 1: Create mask from template's inner white area
    // ═══════════════════════════════════════════════════════
    const maskCanvas = createMaskFromTemplate(patchImg);
    const bounds = getMaskBounds(maskCanvas);
    console.log('📐 Mask bounds:', bounds);

    // ═══════════════════════════════════════════════════════
    // STEP 2: Draw user image with FIT/FILL mode, zoom, and rotation
    // ═══════════════════════════════════════════════════════
    const result = drawImageFitOrFill(ctx, userImg, bounds.x, bounds.y, bounds.w, bounds.h, {
      padding: 2,
      mode: state.fillMode,
      zoom: state.zoom,
      panX: state.panX,
      panY: state.panY,
      rotation: state.imageRotation  // Rotate image counter-clockwise
    });

    console.log('📏 Image drawn:', result.dw.toFixed(0) + 'x' + result.dh.toFixed(0),
                'at', result.dx.toFixed(0) + ',' + result.dy.toFixed(0),
                '(scale:', result.scale.toFixed(2) + ', rot:', state.imageRotation + '°)');

    // ═══════════════════════════════════════════════════════
    // STEP 3: Mask to inner shape
    // ═══════════════════════════════════════════════════════
    ctx.globalCompositeOperation = 'destination-in';
    ctx.drawImage(maskCanvas, 0, 0);
    ctx.globalCompositeOperation = 'source-over';

    // ═══════════════════════════════════════════════════════
    // STEP 4: Draw patch frame ON TOP
    // ═══════════════════════════════════════════════════════
    const frameCanvas = document.createElement('canvas');
    frameCanvas.width = CROP.w;
    frameCanvas.height = CROP.h;
    const frameCtx = frameCanvas.getContext('2d');

    // Draw cropped portion of patch template
    frameCtx.drawImage(patchImg,
      CROP.x, CROP.y, CROP.w, CROP.h,
      0, 0, CROP.w, CROP.h
    );

    // Make inner white pixels transparent
    const frameData = frameCtx.getImageData(0, 0, CROP.w, CROP.h);
    const pixels = frameData.data;
    for (let i = 0; i < pixels.length; i += 4) {
      const brightness = (pixels[i] + pixels[i+1] + pixels[i+2]) / 3;
      if (brightness > 200) {
        pixels[i+3] = 0;  // Transparent
      }
    }
    frameCtx.putImageData(frameData, 0, 0);

    // Draw frame on top
    ctx.drawImage(frameCanvas, 0, 0);

    // ═══════════════════════════════════════════════════════
    // COMPLETE
    // ═══════════════════════════════════════════════════════
    state.processedPatch = canvas.toDataURL('image/png', 0.95);
    console.log('✅ v19 complete -', state.fillMode, 'mode, zoom:', state.zoom);

    updateUploadPreviewWithPatch();
    updatePatchPreview();
    updateButtons();

    return canvas;
  }

  // Helper: Draw rounded rect PATH (for clipping)
  function drawRoundedRectPath(ctx, x, y, w, h, r) {
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r);
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
  }

  // Helper function to draw rounded rectangle
  function drawRoundedRect(ctx, x, y, width, height, radius) {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
  }

  function updatePatchPreview() {
    // Only show patch if BOTH image uploaded AND hat selected
    if (state.processedPatch && state.selectedHat) {
      elements.patchPreview.src = state.processedPatch;
      elements.patchOverlay.style.display = 'block';
      // Initialize drag functionality
      initDragAndResize();
    } else {
      // Hide patch if conditions not met
      elements.patchOverlay.style.display = 'none';
    }
  }

  // 4-Corner control system - Global state
  let corners = {
    tl: { x: 0, y: 0 },
    tr: { x: 150, y: 0 },
    bl: { x: 0, y: 150 },
    br: { x: 150, y: 150 }
  };
  let patchBaseLeft = 100;
  let patchBaseTop = 100;
  let activeCorner = null;
  let isDraggingPatch = false;
  let dragStartX = 0;
  let dragStartY = 0;
  let dragStartCornerX = 0;
  let dragStartCornerY = 0;
  let dragStartPatchLeft = 0;
  let dragStartPatchTop = 0;
  let listenersInitialized = false;

  /**
   * Get the actual rendered image bounds within an img element
   * Accounts for object-fit: contain which centers the image with letterboxing
   */
  function getRenderedImageBounds(img) {
    const elementWidth = img.clientWidth;
    const elementHeight = img.clientHeight;
    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;

    if (!naturalWidth || !naturalHeight) {
      // Image not loaded yet, return element bounds
      return { offsetX: 0, offsetY: 0, width: elementWidth, height: elementHeight };
    }

    const elementAspect = elementWidth / elementHeight;
    const imageAspect = naturalWidth / naturalHeight;

    let renderedWidth, renderedHeight, offsetX, offsetY;

    if (imageAspect > elementAspect) {
      // Image is wider - fits width, letterboxed top/bottom
      renderedWidth = elementWidth;
      renderedHeight = elementWidth / imageAspect;
      offsetX = 0;
      offsetY = (elementHeight - renderedHeight) / 2;
    } else {
      // Image is taller - fits height, pillarboxed left/right
      renderedHeight = elementHeight;
      renderedWidth = elementHeight * imageAspect;
      offsetX = (elementWidth - renderedWidth) / 2;
      offsetY = 0;
    }

    return { offsetX, offsetY, width: renderedWidth, height: renderedHeight };
  }

  function initDragAndResize() {
    const patch = elements.patchOverlay;
    const hatImg = elements.hatPreview;
    if (!patch || !hatImg) return;

    // ═══════════════════════════════════════════════════════════
    // v16: ULTRA-SIMPLE PERCENTAGE-BASED POSITIONING
    // Just use the hat image dimensions directly
    // No complex offset calculations
    // ═══════════════════════════════════════════════════════════

    // Hat image dimensions (already scaled by CSS width: 100%)
    const hatW = hatImg.clientWidth;
    const hatH = hatImg.clientHeight;

    if (hatW === 0 || hatH === 0) {
      console.log('⚠️ Hat dimensions not ready');
      return;
    }

    // v27: Patch size 26% of hat width (+1 unit from 0.25)
    const patchW = hatW * 0.26;
    const patchH = patchW * 1.0;  // Square-ish patch

    // Patch center position - ADJUSTED for actual hat patch location
    // v28-revert: revert v27 (0.57→0.56) — user wanted rotate, not translate
    const patchCenterXPct = 0.56;  // 56% from left
    const patchCenterYPct = 0.50;  // 50% from top

    // Calculate position (center-based, then convert to top-left)
    const patchLeft = (hatW * patchCenterXPct) - (patchW / 2);
    const patchTop = (hatH * patchCenterYPct) - (patchH / 2);

    // Apply positioning (absolute within wrapper)
    patch.style.position = 'absolute';
    patch.style.left = patchLeft + 'px';
    patch.style.top = patchTop + 'px';
    patch.style.width = patchW + 'px';
    patch.style.height = patchH + 'px';
    patch.style.transform = 'rotate(2deg)';  // v32: +1deg more clockwise tilt (1deg→2deg)
    patch.style.transformOrigin = 'center center';
    patch.style.pointerEvents = 'none';

    // Remove old handles
    patch.querySelectorAll('.corner-handle').forEach(h => h.remove());

    // Handle both img AND canvas
    const media = patch.querySelector('img, canvas');
    if (media) {
      media.style.width = '100%';
      media.style.height = '100%';
      media.style.pointerEvents = 'none';
      if (media.tagName.toLowerCase() === 'img') {
        media.style.objectFit = 'contain';
      }
    }

    console.log('📍 Patch v17:', {
      hat: hatW + 'x' + hatH,
      patch: patchW.toFixed(0) + 'x' + patchH.toFixed(0),
      pos: patchLeft.toFixed(0) + ',' + patchTop.toFixed(0)
    });
  }

  function positionCornerHandles(patch) {
    const w = parseInt(patch.style.width) || 150;
    const h = parseInt(patch.style.height) || 150;

    const handlePositions = {
      tl: { left: -10, top: -10 },
      tr: { left: w - 10, top: -10 },
      bl: { left: -10, top: h - 10 },
      br: { left: w - 10, top: h - 10 }
    };

    patch.querySelectorAll('.corner-handle').forEach(handle => {
      const id = handle.dataset.corner;
      const pos = handlePositions[id];
      handle.style.left = pos.left + 'px';
      handle.style.top = pos.top + 'px';
    });
  }

  function handleCornerMouseDown(e) {
    e.preventDefault();
    e.stopPropagation();
    activeCorner = e.target.dataset.corner;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    dragStartCornerX = corners[activeCorner].x;
    dragStartCornerY = corners[activeCorner].y;
  }

  function handleCornerTouchStart(e) {
    e.preventDefault();
    e.stopPropagation();
    const touch = e.touches[0];
    activeCorner = e.target.dataset.corner;
    dragStartX = touch.clientX;
    dragStartY = touch.clientY;
    dragStartCornerX = corners[activeCorner].x;
    dragStartCornerY = corners[activeCorner].y;
  }

  function handlePatchMouseDown(e) {
    e.preventDefault();
    isDraggingPatch = true;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    dragStartPatchLeft = patchBaseLeft;
    dragStartPatchTop = patchBaseTop;
  }

  function handlePatchTouchStart(e) {
    e.preventDefault();
    const touch = e.touches[0];
    isDraggingPatch = true;
    dragStartX = touch.clientX;
    dragStartY = touch.clientY;
    dragStartPatchLeft = patchBaseLeft;
    dragStartPatchTop = patchBaseTop;
  }

  function setupGlobalListeners() {
    // Mouse events
    document.addEventListener('mousemove', handleGlobalMouseMove);
    document.addEventListener('mouseup', handleGlobalMouseUp);

    // Touch events
    document.addEventListener('touchmove', handleGlobalTouchMove, { passive: false });
    document.addEventListener('touchend', handleGlobalTouchEnd);
  }

  function handleGlobalMouseMove(e) {
    if (activeCorner) {
      const dx = e.clientX - dragStartX;
      const dy = e.clientY - dragStartY;
      corners[activeCorner].x = dragStartCornerX + dx;
      corners[activeCorner].y = dragStartCornerY + dy;
      updatePatchFromCorners();
      updateCoordDisplay();
    } else if (isDraggingPatch) {
      const dx = e.clientX - dragStartX;
      const dy = e.clientY - dragStartY;
      patchBaseLeft = dragStartPatchLeft + dx;
      patchBaseTop = dragStartPatchTop + dy;
      updatePatchPosition();
      updateCoordDisplay();
    }
  }

  function handleGlobalTouchMove(e) {
    if (activeCorner || isDraggingPatch) {
      e.preventDefault();
      const touch = e.touches[0];
      if (activeCorner) {
        const dx = touch.clientX - dragStartX;
        const dy = touch.clientY - dragStartY;
        corners[activeCorner].x = dragStartCornerX + dx;
        corners[activeCorner].y = dragStartCornerY + dy;
        updatePatchFromCorners();
        updateCoordDisplay();
      } else if (isDraggingPatch) {
        const dx = touch.clientX - dragStartX;
        const dy = touch.clientY - dragStartY;
        patchBaseLeft = dragStartPatchLeft + dx;
        patchBaseTop = dragStartPatchTop + dy;
        updatePatchPosition();
        updateCoordDisplay();
      }
    }
  }

  function handleGlobalMouseUp() {
    activeCorner = null;
    isDraggingPatch = false;
  }

  function handleGlobalTouchEnd() {
    activeCorner = null;
    isDraggingPatch = false;
  }

  function updatePatchPosition() {
    const patch = elements.patchOverlay;
    if (!patch) return;
    patch.style.left = patchBaseLeft + 'px';
    patch.style.top = patchBaseTop + 'px';
  }

  function updatePatchFromCorners() {
    const patch = elements.patchOverlay;
    if (!patch) return;

    // Calculate bounding box from corners
    const minX = Math.min(corners.tl.x, corners.tr.x, corners.bl.x, corners.br.x);
    const maxX = Math.max(corners.tl.x, corners.tr.x, corners.bl.x, corners.br.x);
    const minY = Math.min(corners.tl.y, corners.tr.y, corners.bl.y, corners.br.y);
    const maxY = Math.max(corners.tl.y, corners.tr.y, corners.bl.y, corners.br.y);

    const width = Math.max(50, maxX - minX);
    const height = Math.max(50, maxY - minY);

    // Update patch size
    patch.style.width = width + 'px';
    patch.style.height = height + 'px';

    // Update each corner handle position using left/top only
    const handles = patch.querySelectorAll('.corner-handle');
    handles.forEach(h => {
      const id = h.dataset.corner;
      const relX = corners[id].x - minX;
      const relY = corners[id].y - minY;

      // Clear right/bottom positioning
      h.style.right = 'auto';
      h.style.bottom = 'auto';
      // Set left/top
      h.style.left = (relX - 15) + 'px';
      h.style.top = (relY - 15) + 'px';
    });

    // Apply perspective transform using clip-path for the quad shape
    const relTL = { x: corners.tl.x - minX, y: corners.tl.y - minY };
    const relTR = { x: corners.tr.x - minX, y: corners.tr.y - minY };
    const relBR = { x: corners.br.x - minX, y: corners.br.y - minY };
    const relBL = { x: corners.bl.x - minX, y: corners.bl.y - minY };

    const img = patch.querySelector('img');
    if (img) {
      // Use clip-path for the quad shape
      img.style.clipPath = 'polygon(' +
        relTL.x + 'px ' + relTL.y + 'px, ' +
        relTR.x + 'px ' + relTR.y + 'px, ' +
        relBR.x + 'px ' + relBR.y + 'px, ' +
        relBL.x + 'px ' + relBL.y + 'px)';
      img.style.width = '100%';
      img.style.height = '100%';
    }

    // Adjust base position to account for corner movement
    const offsetX = minX;
    const offsetY = minY;
    if (offsetX !== 0 || offsetY !== 0) {
      patchBaseLeft += offsetX;
      patchBaseTop += offsetY;
      patch.style.left = patchBaseLeft + 'px';
      patch.style.top = patchBaseTop + 'px';

      // Reset corners relative to new position
      Object.keys(corners).forEach(id => {
        corners[id].x -= offsetX;
        corners[id].y -= offsetY;
      });
    }

    console.log('Patch updated - W:', width, 'H:', height, 'Corners:', corners);
  }

  // Coordinate display panel
  function showCoordDisplay() {
    // Remove existing
    const existing = document.querySelector('.coord-display');
    if (existing) existing.remove();

    const coordDiv = document.createElement('div');
    coordDiv.className = 'coord-display';
    coordDiv.innerHTML = `
      <p><strong>4-CORNER COORDINATES</strong></p>
      <p style="font-size:11px;">Drag each yellow corner to match the patch area</p>
      <hr style="margin: 8px 0; border-color: #444;">
      <p>TL: <span class="highlight" id="coordTL">--</span></p>
      <p>TR: <span class="highlight" id="coordTR">--</span></p>
      <p>BL: <span class="highlight" id="coordBL">--</span></p>
      <p>BR: <span class="highlight" id="coordBR">--</span></p>
      <hr style="margin: 8px 0; border-color: #444;">
      <p>Bounding Box:</p>
      <p>Left: <span class="highlight" id="coordLeft">--</span> | Top: <span class="highlight" id="coordTop">--</span></p>
      <p>Width: <span class="highlight" id="coordWidth">--</span> | Height: <span class="highlight" id="coordHeight">--</span></p>
      <button class="btn btn--coords" id="copyCoords">📋 Copy All Coordinates</button>
    `;
    document.body.appendChild(coordDiv);

    document.getElementById('copyCoords').addEventListener('click', copyCoordinates);

    // Initial update
    setTimeout(updateCoordDisplay, 100);
  }

  function updateCoordDisplay() {
    const patch = elements.patchOverlay;
    const container = elements.previewContainer;

    if (!patch || !container) return;

    const containerRect = container.getBoundingClientRect();
    const patchRect = patch.getBoundingClientRect();

    // Calculate bounding box percentages
    const leftPct = ((patchRect.left - containerRect.left) / containerRect.width * 100).toFixed(1);
    const topPct = ((patchRect.top - containerRect.top) / containerRect.height * 100).toFixed(1);
    const widthPct = (patchRect.width / containerRect.width * 100).toFixed(1);
    const heightPct = (patchRect.height / containerRect.height * 100).toFixed(1);

    // Calculate each corner position as percentage of container
    const baseLeft = patchRect.left - containerRect.left;
    const baseTop = patchRect.top - containerRect.top;
    const minX = Math.min(corners.tl.x, corners.tr.x, corners.bl.x, corners.br.x);
    const minY = Math.min(corners.tl.y, corners.tr.y, corners.bl.y, corners.br.y);

    const cornerPcts = {};
    ['tl', 'tr', 'bl', 'br'].forEach(id => {
      const absX = baseLeft + (corners[id].x - minX);
      const absY = baseTop + (corners[id].y - minY);
      cornerPcts[id] = {
        x: (absX / containerRect.width * 100).toFixed(1),
        y: (absY / containerRect.height * 100).toFixed(1)
      };
    });

    // Update display
    const tlEl = document.getElementById('coordTL');
    const trEl = document.getElementById('coordTR');
    const blEl = document.getElementById('coordBL');
    const brEl = document.getElementById('coordBR');
    const leftEl = document.getElementById('coordLeft');
    const topEl = document.getElementById('coordTop');
    const widthEl = document.getElementById('coordWidth');
    const heightEl = document.getElementById('coordHeight');

    if (tlEl) tlEl.textContent = `(${cornerPcts.tl.x}%, ${cornerPcts.tl.y}%)`;
    if (trEl) trEl.textContent = `(${cornerPcts.tr.x}%, ${cornerPcts.tr.y}%)`;
    if (blEl) blEl.textContent = `(${cornerPcts.bl.x}%, ${cornerPcts.bl.y}%)`;
    if (brEl) brEl.textContent = `(${cornerPcts.br.x}%, ${cornerPcts.br.y}%)`;
    if (leftEl) leftEl.textContent = leftPct + '%';
    if (topEl) topEl.textContent = topPct + '%';
    if (widthEl) widthEl.textContent = widthPct + '%';
    if (heightEl) heightEl.textContent = heightPct + '%';
  }

  function copyCoordinates() {
    const tl = document.getElementById('coordTL')?.textContent || '--';
    const tr = document.getElementById('coordTR')?.textContent || '--';
    const bl = document.getElementById('coordBL')?.textContent || '--';
    const br = document.getElementById('coordBR')?.textContent || '--';
    const left = document.getElementById('coordLeft')?.textContent || '--';
    const top = document.getElementById('coordTop')?.textContent || '--';
    const width = document.getElementById('coordWidth')?.textContent || '--';
    const height = document.getElementById('coordHeight')?.textContent || '--';

    const coordText = `/* 4-Corner Patch Coordinates */
TL (top-left): ${tl}
TR (top-right): ${tr}
BL (bottom-left): ${bl}
BR (bottom-right): ${br}

/* Bounding Box */
left: ${left};
top: ${top};
width: ${width};
height: ${height};`;

    navigator.clipboard.writeText(coordText).then(() => {
      alert('Coordinates copied!\n\n' + coordText);
    });
  }

  function updateButtons() {
    const hasDesign = state.selectedHat && state.uploadedImage && state.processedPatch;
    const copyrightAccepted = elements.copyrightCheckbox ? elements.copyrightCheckbox.checked : true;
    const canAddToCart = hasDesign && copyrightAccepted;
    if (elements.addToCartBtn) {
      elements.addToCartBtn.disabled = !canAddToCart;
    }
  }

  // Export Functions
  function downloadDesign() {
    if (!state.selectedHat || !state.processedPatch) return;

    elements.downloadBtn.classList.add('loading');

    // Load hat image
    const hatImg = new Image();
    hatImg.crossOrigin = 'anonymous';
    hatImg.onload = () => {
      const canvas = elements.exportCanvas;
      const ctx = canvas.getContext('2d');

      // Set canvas size to hat image
      canvas.width = hatImg.naturalWidth;
      canvas.height = hatImg.naturalHeight;

      // Draw hat
      ctx.drawImage(hatImg, 0, 0);

      // Calculate patch position (Design Tool exact coordinates)
      const patchX = canvas.width * 0.22;  // 22% from left
      const patchY = canvas.height * 0.25; // 25% from top
      const patchW = canvas.width * 0.53;  // 53% width
      const patchH = canvas.height * 0.50; // 50% height

      // Load and draw patch
      const patchImg = new Image();
      patchImg.onload = () => {
        ctx.save();

        // Calculate center point for rotation
        const centerX = patchX + patchW / 2;
        const centerY = patchY + patchH / 2;

        // Apply rotation (-0.7 degrees as per Design Tool)
        ctx.translate(centerX, centerY);
        ctx.rotate(-0.7 * Math.PI / 180);
        ctx.translate(-centerX, -centerY);

        // Draw the patch
        ctx.drawImage(patchImg, patchX, patchY, patchW, patchH);

        ctx.restore();

        // Download
        const link = document.createElement('a');
        const timestamp = new Date().toISOString().slice(0, 10);
        link.download = `blackbork-custom-design-${timestamp}.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();

        elements.downloadBtn.classList.remove('loading');

        // Track download
        if (typeof fbq !== 'undefined') {
          fbq('trackCustom', 'DesignDownloaded');
        }
      };
      patchImg.src = state.processedPatch;
    };

    hatImg.onerror = () => {
      alert('Error al cargar la imagen. Por favor, inténtalo de nuevo.');
      elements.downloadBtn.classList.remove('loading');
    };

    hatImg.src = getHatImageUrl(state.selectedHat.hatId);
  }

  // Generate unique design code
  function generateDesignCode() {
    const timestamp = Date.now().toString(36).toUpperCase();
    const random = Math.random().toString(36).substring(2, 6).toUpperCase();
    return 'BB-' + timestamp + '-' + random;
  }

  // ═══════════════════════════════════════════════════════════
  // COPYRIGHT IMAGE CHECK (v11) - Vision AI analysis
  // ═══════════════════════════════════════════════════════════
  async function checkImageCopyright(imageDataUrl) {
    try {
      const response = await fetch('https://chronoslab.es/api/custom-patch/check-image', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image_data: imageDataUrl })
      });

      if (!response.ok) {
        console.log('Copyright check server error:', response.status);
        return true;  // Don't block on server errors
      }

      const result = await response.json();
      console.log('Copyright check result:', result);

      if (result.risk_level === 'blocked') {
        showCopyrightBlockedAlert(result);
        return false;
      }

      if (result.risk_level === 'warning') {
        console.warn('Copyright warning:', result.reason_es);
        // Allow but log warning
      }

      return true;
    } catch (error) {
      console.error('Copyright check error:', error);
      return true;  // Don't block on network errors
    }
  }

  function showCopyrightBlockedAlert(result) {
    const detected = result.detected_elements ? result.detected_elements.join(', ') : '';
    const message = result.reason_es || 'Contenido protegido por derechos de autor detectado.';

    // Create a styled alert overlay
    const overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.6);z-index:10001;display:flex;align-items:center;justify-content:center;padding:20px;';
    overlay.innerHTML = '<div style="background:#fff;border-radius:16px;padding:30px;max-width:440px;width:100%;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,0.3);">' +
      '<div style="width:60px;height:60px;border-radius:50%;background:#fee;margin:0 auto 15px;display:flex;align-items:center;justify-content:center;">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="#dc3545" stroke-width="2" width="30" height="30"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg></div>' +
      '<h3 style="margin:0 0 10px;color:#333;">Contenido Protegido Detectado</h3>' +
      '<p style="color:#666;margin:0 0 15px;line-height:1.5;">' + message + '</p>' +
      (detected ? '<p style="color:#999;font-size:0.85rem;margin:0 0 20px;">Detectado: ' + detected + '</p>' : '') +
      '<button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:#333;color:#fff;border:none;padding:12px 30px;border-radius:10px;font-weight:600;cursor:pointer;">Entendido</button>' +
      '</div>';
    document.body.appendChild(overlay);

    // Reset file input
    if (elements.fileInput) elements.fileInput.value = '';
  }

  // ═══════════════════════════════════════════════════════════
  // EMAIL MODAL (v10) - For non-logged-in users
  // Shows email input for digital signature / copyright tracking
  // ═══════════════════════════════════════════════════════════
  function showEmailModal() {
    return new Promise((resolve, reject) => {
      const modal = document.getElementById('emailModal');
      const input = document.getElementById('emailModalInput');
      const error = document.getElementById('emailModalError');
      const confirmBtn = document.getElementById('emailModalConfirm');
      const cancelBtn = document.getElementById('emailModalCancel');

      if (!modal || !input) { resolve(null); return; }

      modal.style.display = 'flex';
      input.value = '';
      error.style.display = 'none';
      input.focus();

      function cleanup() {
        modal.style.display = 'none';
        confirmBtn.removeEventListener('click', onConfirm);
        cancelBtn.removeEventListener('click', onCancel);
        input.removeEventListener('keydown', onKeydown);
      }

      function onConfirm() {
        const email = input.value.trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          error.style.display = 'block';
          input.classList.add('error');
          return;
        }
        cleanup();
        resolve(email);
      }

      function onCancel() {
        cleanup();
        reject(new Error('cancelled'));
      }

      function onKeydown(e) {
        if (e.key === 'Enter') onConfirm();
        if (e.key === 'Escape') onCancel();
        error.style.display = 'none';
        input.classList.remove('error');
      }

      confirmBtn.addEventListener('click', onConfirm);
      cancelBtn.addEventListener('click', onCancel);
      input.addEventListener('keydown', onKeydown);
    });
  }

  async function addToCart() {
    if (!state.selectedHat || !state.uploadedImage || !state.processedPatch) return;

    // Check copyright disclaimer
    if (elements.copyrightCheckbox && !elements.copyrightCheckbox.checked) {
      if (elements.copyrightDisclaimer) {
        elements.copyrightDisclaimer.classList.add('error');
        elements.copyrightDisclaimer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    // v10: If user is NOT logged in, show email modal for digital signature
    if (!window.CUSTOMER_INFO) {
      try {
        const email = await showEmailModal();
        if (email) {
          state.copyrightEmail = email;
          state.copyrightAcceptedAt = new Date().toISOString();
          console.log('📧 Copyright email collected:', email);
        }
      } catch (e) {
        // User cancelled the modal
        console.log('📧 Email modal cancelled');
        return;
      }
    }

    elements.addToCartBtn.classList.add('loading');

    try {
      // Custom patch product variant IDs
      const CUSTOM_PATCH_INDIVIDUAL_ID = 56702621319551;  // SKU: 10-000-00, €16 (solo parche)
      const CUSTOM_PATCH_COMBO_ID = 56942137409919;       // SKU: 10-000-COMBO, €4 (con gorra)

      // Generate design code if not already generated
      if (!state.designCode) {
        state.designCode = generateDesignCode();
      }

      // Upload image to server for order processing
      await uploadPatchImage();

      // Prepare cart items array
      const items = [];

      // Check if "add hat" checkbox is checked
      const addHatCheckbox = document.getElementById('addHatCheckbox');
      const hatVariantId = state.selectedHat.variantId;
      let hatPrice = 0;
      const addHat = addHatCheckbox && addHatCheckbox.checked && hatVariantId;

      // Generate bundle ID if adding hat (to link patch + hat)
      const bundleId = addHat ? 'CP' + Date.now().toString(36) : null;

      // Add custom patch - combo (€0, price included in hat) or individual (€16)
      const patchVariantId = addHat ? CUSTOM_PATCH_COMBO_ID : CUSTOM_PATCH_INDIVIDUAL_ID;
      items.push({
        id: patchVariantId,
        quantity: 1,
        properties: {
          '_diseño': state.designCode,
          '_gorra': state.selectedHat.hatId,
          '_fecha': new Date().toLocaleDateString('es-ES'),
          '_custom_patch': 'true',
          '_design_image_url': 'https://chronoslab.es/cdn/custom-patches/' + state.designCode + '.png',
          ...(bundleId && { '_bundle_id': bundleId, '_combo_type': 'custom_patch_con_gorra' })
        }
      });

      if (addHat) {
        hatPrice = getHatPrice(state.selectedHat.hatId);
        items.push({
          id: hatVariantId,
          quantity: 1,
          properties: {
            '_bundle_id': bundleId,
            '_combo_type': 'gorra_con_custom_patch',
            '_custom_patch_design': state.designCode
          }
        });
        console.log('🧢 Adding hat to cart:', state.selectedHat.hatId, 'Variant:', hatVariantId, 'Bundle:', bundleId);
      }

      // Prepare cart data
      const formData = { items };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        // Track add to cart - combo: hat price (includes €4 patch), solo: €16
        const totalValue = addHat ? hatPrice : 16;
        const contentIds = ['10-000-00'];
        if (addHat) contentIds.push(state.selectedHat.hatId);

        if (typeof fbq !== 'undefined') {
          fbq('track', 'AddToCart', {
            content_type: 'product',
            content_name: 'Parche personalizado por Gorra de BlackBörk',
            content_ids: contentIds,
            currency: 'EUR',
            value: totalValue
          });
        }

        // Redirect to cart
        window.location.href = '/cart';
      } else {
        const errorData = await response.json();
        console.error('Cart error:', errorData);
        throw new Error(errorData.description || 'Error adding to cart');
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      alert('Error al añadir al carrito: ' + error.message);
    } finally {
      elements.addToCartBtn.classList.remove('loading');
    }
  }

  // v24c: Upload FLAT PATCH + ORIGINAL IMAGE to server for printing
  // This sends both: processed patch and original uploaded image
  async function uploadPatchImage(retryCount = 0) {
    if (!state.designCode) throw new Error('No design code');

    // Use flat patch for print (with zoom, no rotation) - or fallback to original
    const imageToUpload = state.flatPatchForPrint || state.processedPatch;
    if (!imageToUpload) throw new Error('No image to upload');

    const MAX_RETRIES = 2;

    try {
      const response = await fetch('https://chronoslab.es/api/custom-patch/upload', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          design_code: state.designCode,
          image_data: imageToUpload,  // Processed patch with frame (ready for printing)
          original_data: state.uploadedImage,  // v24c: Original uploaded image (raw)
          hat_id: state.selectedHat ? state.selectedHat.hatId : 'unknown',
          timestamp: new Date().toISOString(),
          settings: {  // Include settings for reference
            fillMode: state.fillMode,
            zoom: state.zoom
          },
          // Customer info and copyright agreement
          customer: window.CUSTOMER_INFO ? {
            name: window.CUSTOMER_INFO.name,
            email: window.CUSTOMER_INFO.email,
            id: window.CUSTOMER_INFO.id
          } : null,
          // v10: Email from modal for non-logged-in users
          copyright_email: state.copyrightEmail || '',
          copyright_accepted_at: state.copyrightAcceptedAt || '',
          copyright_agreed: true,
          copyright_agreed_at: new Date().toISOString(),
          copyright_text: "El diseno/fotografia que he subido es de mi propiedad y no contiene ningun contenido protegido por derechos de autor. Asumo toda la responsabilidad legal sobre el uso de este diseno."
        })
      });

      if (response.ok) {
        const result = await response.json();
        console.log('v24c: Patch + original uploaded:', result);
      } else if (response.status === 413 && retryCount === 0) {
        // Image too large - retry without original_data to reduce payload size
        console.warn('Upload too large, retrying without original image...');
        const retryResponse = await fetch('https://chronoslab.es/api/custom-patch/upload', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            design_code: state.designCode,
            image_data: imageToUpload,
            hat_id: state.selectedHat ? state.selectedHat.hatId : 'unknown',
            timestamp: new Date().toISOString(),
            customer: window.CUSTOMER_INFO ? {
              name: window.CUSTOMER_INFO.name,
              email: window.CUSTOMER_INFO.email,
              id: window.CUSTOMER_INFO.id
            } : null,
            copyright_email: state.copyrightEmail || '',
            copyright_accepted_at: state.copyrightAcceptedAt || '',
            copyright_agreed: true,
            copyright_agreed_at: new Date().toISOString(),
            copyright_text: "El diseno/fotografia que he subido es de mi propiedad y no contiene ningun contenido protegido por derechos de autor. Asumo toda la responsabilidad legal sobre el uso de este diseno."
          })
        });
        if (retryResponse.ok) {
          console.log('v24c: Patch uploaded (without original):', await retryResponse.json());
        } else {
          throw new Error('No se pudo guardar el diseño. Inténtalo de nuevo.');
        }
      } else {
        throw new Error('No se pudo guardar el diseño (error ' + response.status + '). Inténtalo de nuevo.');
      }
    } catch (error) {
      if (retryCount < MAX_RETRIES && !error.message.includes('No se pudo')) {
        console.warn('Upload attempt ' + (retryCount + 1) + ' failed, retrying...', error);
        await new Promise(r => setTimeout(r, 1000 * (retryCount + 1)));
        return uploadPatchImage(retryCount + 1);
      }
      console.error('Upload failed after retries:', error);
      throw new Error(error.message || 'Error al guardar el diseño. Comprueba tu conexión e inténtalo de nuevo.');
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
